import { EMAIL_DESIGNER } from "../../constants/action-types";

const initialState = {
  beeAuth: undefined,
  isTriggeredSend : false,
  beeUnsavedChanges: false,
  onTemplateSaved: [],
  saveDesign: [],
  onSend: [],
  seedList: [],
  testEmailList: [],
  sendTestEmail: [],
  templateList: [],
  stockFolderList: [],
  shareFolderList: [],
  templateByID: [],
  templateDesignViewMode: "largeTiles",
  designList: [],
  designByID: [],
  DesignFolders: [],
  trackingParams: [],
  unPublish: [],
  pause: [],
  resume: [],
  designDuplicated: [],
  move: [],
  archive: [],
  folderRenamed: [],
  folderAdded: [],
  suppressionList: [],
  audienceCampaignList: [],
  audienceCampaignCount: null,
  suppressionCampaignCount: null,
  emailSent: [],
  getAllFoldersTreeview: [],
  replyAddresses: [],
  fromAddresses: [],
  imageLibraryContent: [],
  selectedFolderName: "",
  addDirectory: [],
  uploadImage: [],
  validateUpload: [],
  deleteContent: [],
  replaceImage: [],
  reportOverViewEmailSummary: [],
  reportOverViewOpenAndClickRat: [],
  topBottomPerformingSummary: [],
  designsCount: [],
  clientDesigns: [],
  clientDesignDetail: [],
  subscriberTopLinks: [],
  subscriberMostopens: [],
  subscribersDetails: [],
  touchPointMapping: [],
  //saveTouchPointMapping: [],
  imageLibraryFolders: [],
  scheduleTrigger: [],
  saveScheduleInformation: [],
  designBreadcrumbs: [],
  templateBreadcrumbs: [],
  beeMrgeTags: [],
  movedImages: [],
  imageLibraryBreadcrumbs: [],
  clientFonts: undefined, // undefined = not yet fetched; [] = fetched but no fonts
  // undefined = not yet fetched; [] = fetched but no colours. The editor holds its start until
  // this stops being undefined, so an initial [] made that guard do nothing and let the editor
  // boot with an empty palette. Every consumer already reads it as `clientColors || []`.
  clientColors: undefined,
  clientContentDefaults: undefined, // undefined = not yet fetched; null = fetched but no data
  // Per-brand Content Defaults, keyed by brandId (Feature 73469). Kept separate from
  // clientContentDefaults, which means "the client's default brand" and is read by the email
  // editor, form builder and survey builder — a brand-scoped fetch must not land in it.
  brandContentDefaults: {},
  clientAiTrainingHub: undefined, // undefined = not yet fetched; null = fetched but no data
  designScheduleTrigger: [],
  disabledSchedule_info: [],
  disabledEditSchedule_info: [],
  sendsPage: [],
  isAppendTrackingParams: [],
  dynamicFields: [],
  dynamicContentFields: [],
  designInterval:null,
  externalUrlValid: false,
  externalImages: [],
  externalCategories: [],
  savedRowsCategories: [],
  savedRows: [],
  onSaveRow: [],
  saveRowWarningMessage: "",
  sendEmailSendTo: null,
  sendEmailFrom: null,
  sendEmailProperties: null,
  sendEmailShedule: null,
  sendEmailPlayTouchpoint: null,
  isCreditUsageHardLimit: false,
  totalCredit: 0,
  usedCredit: 0,
  listSendFileValidationObject: null,
  abandonCartSpecialLinks: [],
  surveySpecialLinks: [],
  designPreview: {
    designName: '',
    beeAuthResponse: null,
    json: null,
    html: '',
    loading: false,
    error: false
  },
  designIdByPartition: null,
  publicPreviewLink: "",
  isGeneratingLink: false,
  isRevokingLink: false,
  showRevokeConfirm: false,

  // Tracking Params
  TrackingParameters: [
    {
        trackingParameterId: 0,
        trackingParameterName: "",
        trackingParameterValue: ""
    }
],
trackingParameterSelectedItem: [],
ReloadBeeEditor : false,

  aiGenerateDesign: {
    loading: false,
    stage: 0, 
    error: null,
    data: null
  },
  beeCheck: {
    loading: false,
    results: null,
    error: null
  }
};

const EmailDesigner = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_DESIGNER.HANDLE_TRACKING_PARAMETERS: {
      return Object.assign({}, state, {
        TrackingParameters: action.payload
      })
    }
     case EMAIL_DESIGNER.RELOAD_BEE_EDITOR: {
      console.log("EMAIL_DESIGNER.RELOAD_BEE_EDITOR => ", action.payload);
      return {...state, ReloadBeeEditor : action.payload}
    }
    case EMAIL_DESIGNER.HANDLE_TRACKING_PARAMETERS_SELECTED_ITEM: {
      return Object.assign({}, state, {
        trackingParameterSelectedItem: action.payload
      })
    }
    case EMAIL_DESIGNER.BEE_AUTH: {
      return Object.assign({}, state, {
        beeAuth: action.payload,
      });
    }
    case EMAIL_DESIGNER.UPDATE_IS_TRIGGERED_SEND_VALUE: {
      return Object.assign({}, state, {
        isTriggeredSend: action.payload,
      });
    }
    case EMAIL_DESIGNER.BEE_UNSAVED_CHANGES: {
      return Object.assign({}, state, {
        beeUnsavedChanges: action.payload,
      });
    }
    case EMAIL_DESIGNER.REMOVE_BEE_AUTH: {
      return Object.assign({}, state, {
        beeAuth: action.payload,
      });
    }
    case EMAIL_DESIGNER.ON_SAVE_TEMPLATE: {
      return Object.assign({}, state, {
        onTemplateSaved: action.payload,
      });
    }
    case EMAIL_DESIGNER.ON_SAVE_DESIGN: {
      return Object.assign({}, state, {
        saveDesign: action.payload,
      });
    }
    case EMAIL_DESIGNER.SEND_TEST_EMAIL: {
      return Object.assign({}, state, {
        sendTestEmail: action.payload,
      });
    }
    case EMAIL_DESIGNER.SEED_LIST: {
      return Object.assign({}, state, {
        seedList: action.payload,
      });
    }
    case EMAIL_DESIGNER.TEST_EMAIL_LIST: {
      return Object.assign({}, state, {
        testEmailList: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_ALL_TEMPLATES: {
      return Object.assign({}, state, {
        templateList: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_STOCK_FOLDERS: {
      return Object.assign({}, state, {
        stockFolderList: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_SHARE_FOLDERS: {
      return Object.assign({}, state, {
        shareFolderList: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_TEMPLATE_BY_ID: {
      return Object.assign({}, state, {
        templateByID: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_TEMPLATE_DESIGN_VIEW_MODE: {
      return Object.assign({}, state, {
        templateDesignViewMode: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_ALL_DESIGNS: {
      return Object.assign({}, state, {
        designList: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_DESIGN_BY_ID: {
      return Object.assign({}, state, {
        designByID: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_ALL_FOLDERS: {
      return Object.assign({}, state, {
        DesignFolders: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_ALL_TRACKING_PARAMS: {
      return Object.assign({}, state, {
        trackingParams: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_APPEND_TRACKING_PARAMS: {
      return Object.assign({}, state, {
        isAppendTrackingParams: action.payload,
      });
    }
    case EMAIL_DESIGNER.UNPUBLISH: {
      return Object.assign({}, state, {
        unPublish: action.payload,
      });
    }
    case EMAIL_DESIGNER.PAUSE: {
      return Object.assign({}, state, {
        pause: action.payload,
      });
    }
    case EMAIL_DESIGNER.RESUME: {
      return Object.assign({}, state, {
        resume: action.payload,
      });
    }
    case EMAIL_DESIGNER.DUPLICATE: {
      return Object.assign({}, state, {
        designDuplicated: action.payload,
      });
    }
    case EMAIL_DESIGNER.MOVE: {
      return Object.assign({}, state, {
        move: action.payload,
      });
    }

    case EMAIL_DESIGNER.ARCHIVE: {
      return Object.assign({}, state, {
        archive: action.payload,
      });
    }

    case EMAIL_DESIGNER.RENAME: {
      return Object.assign({}, state, {
        folderRenamed: action.payload,
      });
    }
    
    case EMAIL_DESIGNER.ADD_FOLDER: {
      return Object.assign({}, state, {
        folderAdded: action.payload,
      });
    }
    case EMAIL_DESIGNER.SUPPRESION_LIST: {
      return Object.assign({}, state, {
        suppressionList: action.payload,
      });
    }
    case EMAIL_DESIGNER.AUDIENCE_CAMPAIGN_LIST: {
      return Object.assign({}, state, {
        audienceCampaignList: action.payload,
      });
    }
    case EMAIL_DESIGNER.AUDIENCE_CAMPAIGN_COUNT: {
      return Object.assign({}, state, {
        audienceCampaignCount: action.payload,
      });
    }
    case EMAIL_DESIGNER.SUPPRESSION_CAMPAIGN_COUNT: {
      return Object.assign({}, state, {
        suppressionCampaignCount: action.payload,
      });
    }
    case EMAIL_DESIGNER.SEND_EMAIL: {
      return Object.assign({}, state, {
        emailSent: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_ALL_FOLDERS_TREEVIEW: {
      return Object.assign({}, state, {
        getAllFoldersTreeview: action.payload,
      });
    }

    case EMAIL_DESIGNER.GET_REPLY_EMAIL_ADDRESSES: {
      return Object.assign({}, state, {
        replyAddresses: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_FROM_ADDRESSES: {
      return Object.assign({}, state, {
        fromAddresses: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_IMAGE_LIBRARY_CONTENTS: {
      return Object.assign({}, state, {
        imageLibraryContent: action.payload,
      });
    }
    case EMAIL_DESIGNER.SELECTED_FOLDER_NAME: {
      return Object.assign({}, state, {
        selectedFolderName: action.payload,
      });
    }
    case EMAIL_DESIGNER.ADD_DIRECTORY: {
      return Object.assign({}, state, {
        addDirectory: action.payload,
      });
    }
    case EMAIL_DESIGNER.UPLOAD_IMAGE: {
      return Object.assign({}, state, {
        uploadImage: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_DESIGN_UPDATE_INTERVAL: {
      return Object.assign({}, state, {
        designInterval: action.payload,
      });
    }
    case EMAIL_DESIGNER.VALIDATE_UPLOAD: {
      return Object.assign({}, state, {
        validateUpload: action.payload,
      });
    }
    case EMAIL_DESIGNER.DELETE_CONTENT: {
      return Object.assign({}, state, {
        deleteContent: action.payload,
      });
    }
    case EMAIL_DESIGNER.REPLACE_IMAGE: {
      return Object.assign({}, state, {
        replaceImage: action.payload,
      });
    }
    case EMAIL_DESIGNER.REPORT_OVERVIEW_EMAIL_SUMMARY: {
      return Object.assign({}, state, {
        reportOverViewEmailSummary: action.payload,
      });
    }
    case EMAIL_DESIGNER.REPORT_OVERVIEW_OPEN_AND_CLICK_RATE: {
      return Object.assign({}, state, {
        reportOverViewOpenAndClickRat: action.payload,
      });
    }
    case EMAIL_DESIGNER.TOP_BOTTOM_PERFORMING_SUMMARY: {
      return Object.assign({}, state, {
        topBottomPerformingSummary: action.payload,
      });
    }
    case EMAIL_DESIGNER.DESIGN_COUNT_BY_CLIENT: {
      return Object.assign({}, state, {
        designsCount: action.payload,
      });
    }
    case EMAIL_DESIGNER.DESIGN_DROPDOWN_BY_CLIENT: {
      return Object.assign({}, state, {
        clientDesigns: action.payload,
      });
    }
    case EMAIL_DESIGNER.DESIGN_EMAIL_DETAIL: {
      return Object.assign({}, state, {
        clientDesignDetail: action.payload,
      });
    }
    case EMAIL_DESIGNER.REPORT_SUBSCRIBER_TOP_LINKS: {
      return Object.assign({}, state, {
        subscriberTopLinks: action.payload,
      });
    }
    case EMAIL_DESIGNER.REPORT_SUBSCRIBER_MOST_OPENS: {
      return Object.assign({}, state, {
        subscriberMostopens: action.payload,
      });
    }
    case EMAIL_DESIGNER.SUBSCRIBERS_DETAILS: {
      return Object.assign({}, state, {
        subscribersDetails: action.payload,
      });
    }
    case EMAIL_DESIGNER.TOUCHPOINT_MAPPING: {
      return Object.assign({}, state, {
        touchPointMapping: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_DESIGN_PREVIEW:
      return {
        ...state,
        designPreview: {
          ...state.designPreview,
          loading: action.payload.loading,
          error: action.payload.error
        }
      };

    case EMAIL_DESIGNER.GET_DESIGN_PREVIEW_SUCCESS:
      return {
        ...state,
        designPreview: {
          designName: action.payload.designName || '',
          beeAuthResponse: action.payload.beeAuthResponse,
          json: action.payload.json,
          html: action.payload.html,
          loading: action.payload.loading,
          error: action.payload.error
        }
      };

    case EMAIL_DESIGNER.GET_DESIGN_PREVIEW_ERROR:
      return {
        ...state,
        designPreview: {
          ...state.designPreview,
          loading: action.payload.loading,
          error: action.payload.error
        }
      };

    case EMAIL_DESIGNER.GET_DESIGN_ID_BY_PARTITION:
      return {
        ...state,
        designIdByPartition: action.payload
      };

    case EMAIL_DESIGNER.CLEAR_DESIGN_PREVIEW:
      return {
        ...state,
        designPreview: {
          designName: '',
          beeAuthResponse: null,
          json: null,
          html: '',
          loading: false,
          error: false
        },
        designIdByPartition: null
      };
    //case EMAIL_DESIGNER.SAVE_TOUCHPOINT_MAPPING: {
    //  return Object.assign({}, state, {
    //    saveTouchPointMapping: action.payload,
    //  });
    //}
    case EMAIL_DESIGNER.GET_ALL_IMAGE_LIBRARY_FOLDERS_TREEVIEW: {
      return Object.assign({}, state, {
        imageLibraryFolders: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_EXTERNAL_IMAGES: {
      return Object.assign({}, state, {
        externalImages: action.payload,
      });
    }
    case EMAIL_DESIGNER.GET_EXTERNAL_CATEGORIES: {
      return Object.assign({}, state, {
        externalCategories: action.payload,
      });
    }
    case EMAIL_DESIGNER.SAVE_SCHEDULE: {
      return Object.assign({}, state, {
        saveScheduleInformation: action.payload,
      });
    }
    case EMAIL_DESIGNER.SCHEDULE_TRIGGERS: {
      return Object.assign({}, state, {
        scheduleTrigger: action.payload,
      });
    }
    case EMAIL_DESIGNER.DESIGN_BREADCRUMBS_ADD: {
      return {
        ...state,
        designBreadcrumbs: state.designBreadcrumbs.concat(action.payload),
      };
    }
    case EMAIL_DESIGNER.DESIGN_BREADCRUMBS_REMOVE: {
      if (action.payload) {
        return {
          ...state,
          designBreadcrumbs: state.designBreadcrumbs.filter(
            (x) => x.Id <= action.payload
          ),
        };
      } else {
        return {
          ...state,
          designBreadcrumbs: [],
        };
      }
    }
    case EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_ADD: {
      let updatedTemplateBreadcrumbs = state.templateBreadcrumbs.concat(
        action.payload
      );
      return {
        ...state,
        templateBreadcrumbs: updatedTemplateBreadcrumbs,
      };
    }
    case EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_REMOVE: {
      if (action.payload) {
        const item = state.templateBreadcrumbs.filter(
          (x) => x.Id === action.payload
        )[0];
        const index = state.templateBreadcrumbs.indexOf(item);
        if (index > -1) {
          state.templateBreadcrumbs.splice(index, 1);
        }
        return {
          ...state,
        };
      } else {
        return {
          ...state,
          templateBreadcrumbs: [],
        };
      }
    }
    case EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_REMOVE_ALL: {
      if (action.payload > -1) {
        const index = action.payload;
        if (index > -1) {
          state.templateBreadcrumbs.splice(
            index + 1,
            state.templateBreadcrumbs.length - index
          );
        }
        return {
          ...state,
        };
      } else {
        return {
          ...state,
          templateBreadcrumbs: [],
        };
      }
    }
    case EMAIL_DESIGNER.BEE_MERGE_TAGS: {
      return Object.assign({}, state, {
        beeMrgeTags: action.payload,
      });
    }
    case EMAIL_DESIGNER.MOVE_IMAGES: {
      return Object.assign({}, state, {
        movedImages: action.payload,
      });
    }
    case EMAIL_DESIGNER.IMAGE_BREADCRUMBS_ADD: {
      return {
        ...state,
        imageLibraryBreadcrumbs: state.imageLibraryBreadcrumbs.concat(
          action.payload
        ),
      };
    }
    case EMAIL_DESIGNER.IMAGE_BREADCRUMBS_REMOVE: {
      if (action.payload) {
        var index = state.imageLibraryBreadcrumbs.indexOf(action.payload);
        return {
          ...state,
          imageLibraryBreadcrumbs: state.imageLibraryBreadcrumbs.splice(
            0,
            index + 1
          ),
        };
      } else {
        return {
          ...state,
          imageLibraryBreadcrumbs: [],
        };
      }
    }

    case EMAIL_DESIGNER.CLIENT_FONTS: {
      return Object.assign({}, state, {
        clientFonts: action.payload,
      });
    }
    case EMAIL_DESIGNER.CLIENT_COLORS: {
      return Object.assign({}, state, {
        clientColors: action.payload,
      });
    }
    case EMAIL_DESIGNER.CLIENT_CONTENT_DEFAULTS: {
      return Object.assign({}, state, {
        clientContentDefaults: action.payload,
      });
    }
    case EMAIL_DESIGNER.BRAND_CONTENT_DEFAULTS: {
      return Object.assign({}, state, {
        brandContentDefaults: Object.assign({}, state.brandContentDefaults, {
          [action.brandId]: action.payload,
        }),
      });
    }
    case EMAIL_DESIGNER.CLIENT_AI_TRAINING_HUB: {
      return Object.assign({}, state, {
        clientAiTrainingHub: action.payload,
      });
    }
    case EMAIL_DESIGNER.DESIGN_SCHEDULE_TRIGGER: {
      return Object.assign({}, state, {
        designScheduleTrigger: action.payload,
      });
    }
    case EMAIL_DESIGNER.LIST_SEND_FILE_VALIDATION: {
      return Object.assign({}, state, {
        listSendFileValidationObject: action.payload,
      });
    }
    case EMAIL_DESIGNER.DISABLED_SCHEDULED: {
      return Object.assign({}, state, {
        disabledSchedule_info: action.payload,
      });
    }
    case EMAIL_DESIGNER.DISABLED_EDIT_SCHEDULED: {
      return Object.assign({}, state, {
        disabledEditSchedule_info: action.payload,
      });
    }
    case EMAIL_DESIGNER.REPORT_SENDS_PAGE: {
      return Object.assign({}, state, {
        sendsPage: action.payload,
      });
    }
    case EMAIL_DESIGNER.DYNAMICFIELDS: {
      return Object.assign({}, state, {
        dynamicFields: action.payload,
      });
    }
    case EMAIL_DESIGNER.DYNAMIC_CONTENT_FIELDS: {
      return Object.assign({}, state, {
        dynamicContentFields: action.payload,
      });
    }
    case EMAIL_DESIGNER.EXTERNAL_URL_VALIDATION: {
      return Object.assign({}, state, {
        externalUrlValid: action.payload,
      });
    }
    case EMAIL_DESIGNER.SAVED_ROWS_CATEGORIES: {
      return Object.assign({}, state, {
        savedRowsCategories: action.payload,
      });
    }
    case EMAIL_DESIGNER.SAVED_ROWS: {
      return Object.assign({}, state, {
        savedRows: action.payload,
      });
    }
    case EMAIL_DESIGNER.ABANDON_CART_SPECIAL_LINKS: {
      return Object.assign({}, state, {
        abandonCartSpecialLinks: action.payload,
      });
    }
    case EMAIL_DESIGNER.SURVEY_SPECIAL_LINKS: {
      return Object.assign({}, state, {
        surveySpecialLinks: action.payload,
      });
    }
    case EMAIL_DESIGNER.ON_SAVE_ROW: {
      return Object.assign({}, state, {
        onSaveRow: action.payload,
      });
    }
    case EMAIL_DESIGNER.SAVE_ROW_VALIDATION: {
      return Object.assign({}, state, {
        saveRowWarningMessage: action.payload,
      });
    }
    case EMAIL_DESIGNER.SEND_EMAIL_SEND_TO: {
      return {
        ...state,
        sendEmailSendTo: action.payload
      };
    }
    case EMAIL_DESIGNER.SEND_EMAIL_FROM: {
      return {
        ...state,
        sendEmailFrom: action.payload
      };
    }
    case EMAIL_DESIGNER.SEND_EMAIL_PROPERTIES: {
      return {
        ...state,
        sendEmailProperties: action.payload
      };
    }
    case EMAIL_DESIGNER.SEND_EMAIL_SCHEDULE: {
      return {
        ...state,
        sendEmailShedule: action.payload
      };
    }
    case EMAIL_DESIGNER.SEND_EMAIL_PLAY_TOUCHPOINT: {
      return {
        ...state,
        sendEmailPlayTouchpoint: action.payload
      };
    }
    case EMAIL_DESIGNER.SET_SEND_EMAIL_DETAILS: {
      const { payload: {
        sendEmailSendTo,
        sendEmailFrom,
        sendEmailProperties,
        sendEmailShedule,
        sendEmailPlayTouchpoint
       } } = action;
      return {
        ...state,
        sendEmailSendTo,
        sendEmailFrom,
        sendEmailProperties,
        sendEmailShedule,
        sendEmailPlayTouchpoint,
      };
    }
    case EMAIL_DESIGNER.SET_ESP_USER_CREDIT: {
      const { payload: { isHardLimit, total, used }} = action;
      return {
        ...state,
        isCreditUsageHardLimit: isHardLimit,
        totalCredit: total,
        usedCredit: used
      };
    }
    case EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK:
      return {
        ...state,
        isGeneratingLink: action.payload.isGeneratingLink
      };

    case EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_SUCCESS:
      return {
        ...state,
        publicPreviewLink: action.payload.publicPreviewLink,
        isGeneratingLink: action.payload.isGeneratingLink
      };

    case EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_ERROR:
      return {
        ...state,
        isGeneratingLink: action.payload.isGeneratingLink
      };

    case EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK:
      return {
        ...state,
        isRevokingLink: action.payload.isRevokingLink
      };

    case EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_SUCCESS:
      return {
        ...state,
        publicPreviewLink: action.payload.publicPreviewLink,
        isRevokingLink: action.payload.isRevokingLink,
        showRevokeConfirm: action.payload.showRevokeConfirm
      };

    case EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_ERROR:
      return {
        ...state,
        isRevokingLink: action.payload.isRevokingLink,
        showRevokeConfirm: action.payload.showRevokeConfirm
      };

    case EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_SUCCESS:
      return {
        ...state,
        publicPreviewLink: action.payload.publicPreviewLink
      };

    case EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_ERROR:
      return {
        ...state,
        publicPreviewLink: action.payload.publicPreviewLink
      };

    case EMAIL_DESIGNER.CLEAR_PUBLIC_PREVIEW_LINK:
      return {
        ...state,
        publicPreviewLink: action.payload.publicPreviewLink,
        isGeneratingLink: action.payload.isGeneratingLink,
        isRevokingLink: action.payload.isRevokingLink,
        showRevokeConfirm: action.payload.showRevokeConfirm
      };

    case EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_START:
      return {
        ...state,
        aiGenerateDesign: {
          loading: true,
          stage: 1,
          error: null,
          data: null
        }
      };

    case EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_STAGE_2:
      return {
        ...state,
        aiGenerateDesign: {
          loading: true,
          stage: 2,
          error: null,
          data: null
        }
      };

    case EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_SUCCESS:
      return {
        ...state,
        aiGenerateDesign: {
          loading: false,
          stage: 0,
          error: null,
          data: action.payload
        }
      };

    case EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_ERROR:
      return {
        ...state,
        aiGenerateDesign: {
          loading: false,
          stage: 0,
          error: action.payload,
          data: null
        }
      };

    case EMAIL_DESIGNER.BEE_CHECK_REQUEST:
      return {
        ...state,
        beeCheck: {
          loading: true,
          results: null,
          error: null
        }
      };

    case EMAIL_DESIGNER.BEE_CHECK_SUCCESS:
      return {
        ...state,
        beeCheck: {
          loading: false,
          results: action.payload,
          error: null
        }
      };

    case EMAIL_DESIGNER.BEE_CHECK_ERROR:
      return {
        ...state,
        beeCheck: {
          loading: false,
          results: null,
          error: action.payload
        }
      };

    case EMAIL_DESIGNER.BEE_CHECK_CLEAR:
      return {
        ...state,
        beeCheck: {
          loading: false,
          results: null,
          error: null
        }
      };

    default:
      return state;
  }
};

export default EmailDesigner;
